<template>
  <v-main class="frontend">
    <v-app-bar
      :color="
        this.$store.state.modules.options.app_color
          ? this.$store.state.modules.options.app_color
          : '#faa61a'
      "
      fixed
    >
      <v-toolbar-title>
        <a
          class="head"
          @click.prevent="
            $router.push({
              path: '/'
            })
          "
          >{{ this.$store.state.modules.options.app_name }}</a
        ></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-select v-model="$i18n.locale" :items="langs" class="lang mt-1">
      </v-select>

      <v-menu
        v-if="$auth.user().id"
        bottom
        left
        min-width="200"
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            min-width="0"
            text
            v-bind="attrs"
            :loading="isLoggingOut"
            v-on="on"
          >
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list :tile="false" flat nav>
          <template>
            <template v-if="$auth.user().admin">
              <app-bar-item to="/be">
                <v-list-item-title>{{ $t("Backend") }}</v-list-item-title>
              </app-bar-item>
              <app-bar-item :to="'/be/users/' + this.$auth.user().id">
                <v-list-item-title>{{ $t("edit_profile") }}</v-list-item-title>
              </app-bar-item>
            </template>
            <template v-else>
              <app-bar-item :to="{ name: 'frontend.my-family' }">
                <v-list-item-title>{{
                  $t("my_family.menu_button")
                }}</v-list-item-title>
              </app-bar-item>
            </template>
            <app-bar-item @click.prevent="onLogout()">
              <v-list-item-title>Logout</v-list-item-title>
            </app-bar-item>
          </template>
        </v-list>
      </v-menu>
      <v-btn min-width="0" text v-else :to="{ name: 'auth.login' }">
        <v-icon>mdi-login</v-icon>
      </v-btn>
    </v-app-bar>
    <v-img
      :src="
        this.$store.state.modules.options.app_background
          ? this.$store.state.modules.options.app_background
          : '/img/background-login.jpg'
      "
      gradient="to top, rgba(255, 255, 255, .3), rgba(255, 255, 255, .3)"
      min-height="100%"
    >
      <router-view />
    </v-img>
  </v-main>
</template>

<script>
import { VHover, VListItem } from "vuetify/lib";

export default {
  name: "PagesCoreView",
  methods: {
    onLogout() {
      /* eslint-disable no-console */
      console.log("onLogout clicked");
      this.isLoggingOut = true;
      this.$auth.logout();
      window.localStorage.removeItem("laravel-vue-spa");
      this.$auth.logout();
    }
  },
  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  on: this.$listeners,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs
                  }
                },
                this.$slots.default
              );
            }
          }
        });
      }
    }
  },
  data: () => ({
    langs: ["de", "it"],
    isLoggingOut: false
  })
};
</script>

<style lang="sass">
#pages
  > .v-content__wrap > .v-image
    padding-top: 64px
    padding-bottom: 88px

  .v-responsive__sizer
    display: none

  .v-image--md
    padding: 188px 0

  .v-image--sm
    padding: 96px 0 188px 0
</style>

<style lang="scss" scoped>
.content {
  margin-top: 100px;
}
.content.detail {
  max-width: 1000px;
}
.head {
  color: #fff;
  text-decoration: none;
}
.lang {
  max-width: 50px;
}
</style>

<style>
/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #474747 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 16px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #474747;
  border-radius: 10px;
  border: 3px solid #ffffff;
}
</style>
